/** Code for removing a zip code from an address line returned from the API */
export function stripZipCode(addressString) {
	const zipCodeRegex = /\s*\d{5}(?:-\d{4})?\s*$/;
	return addressString.replace(zipCodeRegex, "").trimEnd();
}
